import { colors } from 'component-library/styles/colors';
import React, { FC, SVGProps } from 'react';

export const CaratDown: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.41 0.590088L6 5.1701L10.59 0.590088L12 2.0001L6 8.0001L0 2.0001L1.41 0.590088Z"
      fill={props.fill || colors.navyBlue}
    />
  </svg>
);
